import Animation from './animation'
import * as d3 from 'd3-selection'
import * as scale from 'd3-scale'
import * as array from 'd3-array'
import { EPSILON } from 'chart-constants'

class HierarchyDrilldownAnimation extends Animation {

  match (serie) {
    if (!this.exitingSeries.size()) {
      return false
    }

    let entering = this.series.selection().datum()

    return this.exitingSeries.selection().datum().points.find(point => {
      // One of the exiting points is a parent to this serie.
      return point.rangeId == entering.id
    })
  }

  /*
   * Fetches the previous location data for a nodeId. Will walk the ancestors
   * in case the incoming node's parent wasn't previously in the tree. See #639
   */
  getOldParent (prevBlocks, nodeId) {
    let prev = null
      , block = this.blocks.find(block => block.data.id == nodeId) // Get the hierarchy object
      , ancestors = block.ancestors()
      , i = 0

    while (!prev && i < ancestors.length) {
      let ancestor = ancestors[i++]
      prev = prevBlocks.data().find(prev => prev.data.id == ancestor.data.id)
    }

    return prev
  }

  animate (serie, enter, selection, merged, exit) {
    let prevBlocks = this.exitingSeries.selection().selectAll('.treemap-block')
      , self = this

    if (exit.size()) {
      let newSerie = this.series.selection().datum()
        , exitingPoint = prevBlocks.data().find(point => {
          return point.data.id == newSerie.id
        })
        , xScale = scale.scaleLinear()
                        .domain([exitingPoint.x0, exitingPoint.x1]) // Set the domain of our scalers to be the previous values
                        .rangeRound([0, this.dimensions.width])
        , yScale = scale.scaleLinear()
                        .domain([exitingPoint.y0, exitingPoint.y1])
                        .rangeRound([0, this.dimensions.height])

      // Get the previous node's data
      // Update the position of the previous nodes so they blowup
      exit.attr('transform', d => `translate(${xScale(d.x0)}, ${yScale(d.y0)})`)
          .select('rect')
          .attr('width', d => xScale(d.x1) - xScale(d.x0))
          .attr('height', d => yScale(d.y1) - yScale(d.y0))

    } else {
      // This is the new series
      enter.each(function (d) {
        let prev = prevBlocks.data().find(prev => prev.data.id == d.data.id)

        if (prev) {
          let node = prevBlocks.filter(d => d.data.id == prev.data.id)

          // this block was previously visible. start it at the previous location
          d3.select(this)
            .attr('transform', `translate(${prev.x0}, ${prev.y0})`)
            .select('rect')
              .attr('fill', self.previousColorScale(prev.data.level))
              .attr('width', prev.x1 - prev.x0)
              .attr('height', prev.y1 - prev.y0)

          let label = node.select('.label')
          d3.select(this)
            .select('.label')
            .style('font-size', label.style('font-size'))
            .attr('transform', label.attr('transform'))
          label.style('opacity', EPSILON)
        } else {
          let oldParent = self.getOldParent(prevBlocks, d.data.id)
            , minX = array.min(d.parent.children, node => node.x0)
            , maxX = array.max(d.parent.children, node => node.x1)
            , minY = array.min(d.parent.children, node => node.y0)
            , maxY = array.max(d.parent.children, node => node.y1)
            , xScale = scale.scaleLinear()
                            .domain([minX, maxX])
                            .range([oldParent.x0, oldParent.x1])
            , yScale = scale.scaleLinear()
                            .domain([minY, maxY])
                            .range([oldParent.y0, oldParent.y1])

          d3.select(this)
            .attr('transform', d => `translate(${xScale(d.x0)}, ${yScale(d.y0)})`)
            .select('rect')
              .attr('fill', d => self.colorScale(d.data.level))
              .attr('width', d => xScale(d.x1) - xScale(d.x0))
              .attr('height', d => yScale(d.y1) - yScale(d.y0))

          d3.select(this)
            .select('.label')
            .style('font-size', '0px')
        }
      })

      merged.attr('transform', d => `translate(${d.x0},${d.y0})`)
            .style('opacity', 1)
            .select('rect')
            .attr('fill', d => this.colorScale(d.data.level))
            .attr('width', d => d.x1 - d.x0)
            .attr('height', d => d.y1 - d.y0)

      merged.call(this._labels)
    }

  }

}

export default HierarchyDrilldownAnimation
